<template>
  <div class="manage_page">
    <el-row style="height: 10%;">
      <el-col :span="6" style="margin: 0 0 10px 20px">
        <img src="https://dreamportal-cdn.nextscene.cn/YuyueInspire/avatar.png" style="width: 50px; height: 50px;">
      </el-col>
      <el-col :span="13" style="margin: 10px 0 0 20px;">
        <div style="font-size: 13px">Dream Portal Service</div>
      </el-col>
    </el-row>
    <el-row style="height: 87%;" class="tac">
      <el-col :span="24" style="background-color: #ffffff;">
        <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            @select="handleOpen"
        >
          <el-submenu index="/manage" default-active="buyTicketList" class="custom-menu">
            <template slot="title">
              <div class="submenuStyle">
                <i class="el-icon-location"></i>
                <span>票务后台管理</span>
              </div>
            </template>
          </el-submenu>
          <div style="margin-left: 20px">
            <el-menu-item index="reservationNum">
              <span slot="title">预约信息管理</span>
            </el-menu-item>
            <el-menu-item index="buyTicketList">
              <span slot="title">购票信息管理</span>
            </el-menu-item>
            <el-menu-item index="projectManagement">
              <span slot="title">沉浸式项目管理</span>
            </el-menu-item>
            <el-menu-item index="ticketTypeList">
              <span slot="title">票种管理</span>
            </el-menu-item>
          </div>

        </el-menu>
      </el-col>
    </el-row>
    <div class="logoutStyle" @click="logout">
      <i class="el-icon-switch-button"></i>
      logout
    </div>
  </div>
</template>

<script>


export default {
  computed: {
    defaultActive: function () {
      return this.$route.path.replace('/', '');
    }
  },
  components: {},
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
      // if(key=='manage'){
      this.$router.push(key);
      // }

      // this.$router.push(key);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    logout() {
      // this.$cookies.remove('token')
      // this.$cookies.remove('username')
      // this.$cookies.remove('icon')
      // this.username = ''
      this.$message({
        type: 'success',
        message: '退出成功'
      });
      this.$router.push('/');
    }
  }
}
</script>


<style lang="less" scoped>
@import '../style/mixin';

.manage_page {
  background-color: #FFFFFF;
}

.submenuStyle {
  width: Fixed (233px)px;
  height: Hug (63px)px;
  gap: 10px;
  border-radius: 12px 12px 12px 12px;
  background: #5C16F2;
  color: #FFFFFF;
}

.el-menu-item.is-active {
  color: #5C16F2 !important;
}


/* 使用自定义字体 */
body {
  font-family: 'PingFang SC', sans-serif; /* 应用自定义字体 */
}

.logoutStyle {
  width: 114px;
  height: 46px;
  padding: 11px;
  gap: 10px;
  border-radius: 16px;
  color: #CC5F5F;
  margin: 100px 0 0 30px;
}

</style>
